import LayoutActividad from "../../../components/LayoutActividad";
import { modulo13 } from "../../../routes/Module13";
import Sidebar from "../Sidebar";
import Imagen1 from "../../../images/modulo13/cordillera.png";
import GuiaDocente from "../../../components/GuiaDocente";

const Actividad1 = () => {
  const infoUnidad = modulo13.content[0];
  const infoAct = modulo13.content[0].activities[2];
  const crumbs = [
    {
      title: modulo13.title,
      url: "/" + modulo13.url,
    },
    {
      title:
        modulo13.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];

  const pages = {
    titleNext: `${modulo13.content[0].name}: ${modulo13.content[0].activities[3].name}`,
    linkNext: `${modulo13.url}/${modulo13.content[0].path}/${modulo13.content[0].activities[3].path}`,
    titlePrev: `${modulo13.content[0].name}: ${modulo13.content[0].activities[1].name}`,
    linkPrev: `${modulo13.url}/${modulo13.content[0].path}/${modulo13.content[0].activities[1].path}`,
  };
  const metadata = {
    color: modulo13.color,
    title: `${modulo13.title} - ${infoAct.name}`,
    name: modulo13.title,
  };

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <div className="row mb-3">
        <div className="col-12">
          
          <h2 className="mb-5">{infoAct.name}</h2>

          <div className="bg-light mt-5 p-3 p-md-5">
            <div className="row mt-3 align-items-start">
              <div className="col-md-6 col-12 p-md-3">
              <h2 className="mb-4">Perú, un territorio diverso</h2>

                <p>
                  El territorio que ocupa el Perú es muy variado. Tiene una gran{" "}
                  <strong>diversidad de paisajes</strong>. En las diferentes
                  regiones de nuestro país podemos encontrar mar, ríos, valles,
                  desiertos, bosques, selvas, estepas, punas y sabanas.
                </p>
                <p>
                  Cada uno de estos paisajes tiene <strong>diferentes climas</strong>:
                  unos cálidos y otros bastante fríos o helados. También hay{" "}
                  <strong>distintos relieves</strong>: algunos con muchas montañas y
                  otros llanos. La vegetación y las especies que habitan en
                  estos paisajes también son diversas.
                </p>
                <p>
                  Esta variedad de paisajes es resultado de muchos elementos,
                  entre ellos, la presencia de la cordillera de los Andes.
                </p>
              </div>
              <div className="col-md-6 col-12 text-center">
                <img src={Imagen1} className="img-fluid" alt="Peruanos" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <GuiaDocente>
        <ul>
          <li>
            Pida que lean los tres
            párrafos del texto titulado: Perú, un territorio diverso. Al
            terminar la lectura, puede preguntar sobre la lectura realizada lo
            siguiente:
            <ul>
              <li>
                <i>
                  “¿Cómo es el territorio del Perú? (Posible respuesta: Es
                  diverso. Ello se expresa en la gran variedad de paisajes).
                </i>
              </li>
              <li>
                <i>
                  ¿Qué elementos básicos conforman un paisaje? (Posible
                  respuesta: El relieve, la altura, el clima, la flora y la
                  fauna).
                </i>
              </li>
              <li>
                <i>
                  ¿A qué se debe que el Perú tenga una gran variedad de
                  paisajes? (Posible respuesta: Son distintos factores, uno de
                  ellos es la presencia de la cordillera de los Andes).
                </i>
              </li>
            </ul>
          </li>

          <li>Lea en voz alta, una vez más, el texto.</li>
        </ul>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad1;
